import { render, staticRenderFns } from "./simple-app-method.vue?vue&type=template&id=0e661290"
import script from "./simple-app-method.vue?vue&type=script&lang=js"
export * from "./simple-app-method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports